/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Mac_ArchInputs */

const en_gc_resources_download_mac_arch = /** @type {(inputs: Gc_Resources_Download_Mac_ArchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universal installer: Apple silicon and Intel`)
};

const zh_gc_resources_download_mac_arch = /** @type {(inputs: Gc_Resources_Download_Mac_ArchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通用安装包：Apple 芯片与 Intel`)
};

/**
* | output |
* | --- |
* | "Universal installer: Apple silicon and Intel" |
*
* @param {Gc_Resources_Download_Mac_ArchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_mac_arch = /** @type {((inputs?: Gc_Resources_Download_Mac_ArchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Mac_ArchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_mac_arch(inputs)
	return zh_gc_resources_download_mac_arch(inputs)
});
export { gc_resources_download_mac_arch as "gc.resources.download.mac.arch" }